<template>
    <div class="order__note">
        <h3 class="order__subtitle cart__subtitle">Примечание</h3>

        <div class="input">
            <textarea
                @change="createCommentValue"
                v-model="comment"
                id="text-1"
                class="input__field order__textarea"
                placeholder="Оставьте комментарий"
                :data-element="$root.getDataElement('cart_note_input')"
            ></textarea>
        </div>
    </div>
</template>

<script>
export default {
    name: "NoteComponent",
    data() {
        return {
            comment: ''
        }
    },
    methods: {
        createCommentValue() {
            this.$emit('createCommentValue', this.comment)
        }
    }
}
</script>